import styled from 'styled-components';

const ResumeInfoPeriod = ({ text, startDate, endDate }) => {
  return (
    <>
      <PeriodWrap>
        <PeriodDate className="b1">
          {startDate}
          {endDate !== '' ? (
            <>
              <span>-</span> {endDate}
            </>
          ) : (
            <></>
          )}
        </PeriodDate>
        {text !== '' ? (
          <>
            <StatusFlag>
              <StatusText className="b1">{text}</StatusText>
            </StatusFlag>
          </>
        ) : (
          <></>
        )}
      </PeriodWrap>
    </>
  );
};

const PeriodWrap = styled.div`
  width: 20rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

const PeriodDate = styled.h4`
  color: var(--neutral-gray-600);
  display: flex;
  gap: 1rem;
`;

const StatusFlag = styled.span`
  width: fit-content;
  display: inline-block;
  padding: 1rem;
  border-radius: 10rem;
  background: var(--primary-ivy-green-500);
`;

const StatusText = styled.h4`
  padding: 0 2rem;
  color: var(--neutral-white);
`;

export default ResumeInfoPeriod;
